export const PRIVACY_POLICY_URL = "https://www.gitcha.com/privacy-policy";
export const TERMS_OF_USE_URL = "https://www.gitcha.com/terms-of-use";
